const baseURL = process.env.VUE_APP_PUBLIC_BASE_URL

module.exports = {
  publicPath: baseURL + 'modules/vuejs/vuejs-app/dist/',
  lintOnSave: false,
  configureWebpack: {
    externals: {
      axios: 'axios',
    },
  },
  css: {
    loaderOptions: {
      sass: {
        additionalData: `@import "./src/assets/style/imports.scss";`,
      },
    },
  },
}
